export const optionsSelectNdsValue = [
	{ id: 5, name: '5%' },
	{ id: 7, name: '7%' },
	{ id: 10, name: '10%' },
	{ id: 20, name: '20%' },
]

export const TAXATION_IDS_TYPE = {
	OSN: 1,
	USN: 2,
}
